import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  button: {
    cursor: "pointer",
  },
  changeStatusButton: {
    whiteSpace: "nowrap",
    "& span > div": {
      display: "flex",
      alignItems: "center",
    },
  },
  main: {
    "& .shipeezi-new-grid-component": {
      "& > :nth-child(1)": {
        "& > :nth-child(1)": {
          // Assuming .makeStyles-leftSide-406 is the first child
          width: "unset",
        },
      },
    },
  },
  plusIcon: {
    fontSize: "20px",
    marginRight: "8px",
    marginBottom: "4px",
  },
  pointer: {
    cursor: "pointer",
  },
  status: {
    width: "fit-content",
  },
}));

export default styles;
